export default __webpack_public_path__ + "static/pragicts-cloudops-infrastructure-1d56a40ab24b65b18b2ebe8be414e79e.jpg";